import styled from 'styled-components';
import devices from '../../styles/devices';

export const Container = styled.header`
  .logo {
    display: block;
    margin: 50px auto;

    @media ${devices.md} {
      margin: 25px auto;
    }
  }

  .navbar {
    background: none !important;
    display: flex;
    padding: 0 0 10px;

    .navbar-toggler {
      border-radius: none;
      margin-top: -10px;
    }

    .navbar-nav {
      display: flex;
      width: 100%;
      justify-content: space-evenly;
      text-align: center;
      border-bottom: 1px solid #000;

      @media ${devices.sm} {
        border-bottom: none;
      }

      a {
        display: block;
        color: #696969;
        font-size: 14px;
        font-weight: 100;
        text-transform: uppercase;
        border-bottom: 5px solid transparent;
        text-decoration: none;

        &:hover,
        &.active {
          border-color: #000;

          @media ${devices.sm} {
            text-decoration: underline;
          }
        }

        @media ${devices.sm} {
          border-bottom: none;
          padding: 5px 0;
        }
      }
    }
  }

  .cabecalho {
    background: rgb(42, 145, 147);
    background: linear-gradient(
      0deg,
      rgba(42, 145, 147, 1) 50%,
      rgba(23, 125, 127, 1) 50%
    );
    text-align: center;
    padding: 50px 25px;
  }
`;

export const Greeting = styled.div`
  line-height: 1;
  width: 100%;
  padding-left: 80px;
  @media ${devices.lg} {
    padding-left: 50px;
  }
  @media ${devices.sm} {
    padding-left: 0;
    width: auto;
  }

  .usuario-logado {
    background: #293e93;
    color: #fff !important;
    font-size: 14px;
    padding: 10px;
    font-style: italic;
    text-align: left;
    font-weight: 100;
    margin-bottom: 10px;
    border-radius: 5px !important;

    .nome {
      overflow: hidden;
      text-overflow: ellipsis;
      width: 60%;
      display: inline-block;
      white-space: nowrap;
      color: #fff;

      @media ${devices.sm} {
        width: auto;
        max-width: 100px;
      }
    }

    .sair {
      float: right;
      display: inline-block;
      padding: 0 8px;
      font-weight: bold;
      color: #fff;
      text-decoration: underline;
      margin-left: 8px;
      background: none;
      border: none;
      border-left: 1px solid #fff;
      font-style: italic;

      &:hover {
        color: #fff;
      }
    }
  }

  .btn {
    border: 1px solid #e9ebf4;
    color: #273e92;
    display: block;
    font-style: italic;
    font-weight: bold;
    font-size: 15px;
    border-radius: 0;
    border-radius: 5px !important;
    text-transform: uppercase;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
